import { render } from "./topStarView.vue?vue&type=template&id=06628821&scoped=true"
import script from "./topStarView.vue?vue&type=script&lang=js"
export * from "./topStarView.vue?vue&type=script&lang=js"

import "./topStarView.vue?vue&type=style&index=0&id=06628821&scoped=true&lang=css"

import exportComponent from "/Users/yxgc/Documents/workspace/BeeUiComentPlugin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06628821"]])

export default __exports__